import { SCREEN_SIZE_TYPE } from '@/modules/ui/types';
import moment from 'moment';

export const calculateWindowSize = (windowWidth: number): SCREEN_SIZE_TYPE => {
    if (windowWidth >= 1200) {
        return SCREEN_SIZE_TYPE.LG;
    }
    if (windowWidth >= 992) {
        return SCREEN_SIZE_TYPE.MD;
    }
    if (windowWidth >= 768) {
        return SCREEN_SIZE_TYPE.SM;
    }
    return SCREEN_SIZE_TYPE.XS;
};

export const formatDate = (value: number | Date, pattern: string = 'YYYY-MM-DD HH:mm:ss') => {
    if (!value) {
        return null;
    }

    switch (typeof value) {
        case 'number':
            if (value > 0) {
                return moment(value).format(pattern);
            }
            break;
        case 'object':
            if (value instanceof Date && !isNaN(value.getTime())) {
                return moment(value).format(pattern);
            }
            break;
        default:
            return null;
    }
};

export const toDuration = (milliseconds: number) => moment.duration(milliseconds).locale('en').humanize();

export const pageSize = 10;

export const timeUnits = [
    { value: 0, label: 'Minute' },
    { value: 1, label: 'Hour' },
    { value: 2, label: 'Day' },
    { value: 3, label: 'Week' },
    { value: 4, label: 'Month' }
];

export const booleanOption = [
    { label: 'Yes', value: true, background: 'success' },
    { label: 'No', value: false, background: 'secondary' }
];

export const renderTimeUnit = (value: any) => renderOption(timeUnits, value);
export const renderBoolean = (value: any) => renderOption(booleanOption, value);

export const renderOption = (dataList: Array<{ label: any; value: any; background?: string }>, selectedValue: any) => {
    const selectedOption = dataList.find((item: any) => item.value == selectedValue);
    if (!selectedOption) {
        return '';
    }

    return `<span class='badge badge-${selectedOption?.background ?? 'success'}'>${selectedOption.label}</span>`;
};

const colorList = [
    '#bdc3c7',
    '#1abc9c',
    '#2ecc71',
    '#3498db',
    '#9b59b6',
    '#16a085',
    '#27ae60',
    '#2980b9',
    '#8e44ad',
    '#f1c40f',
    '#e67e22',
    '#e74c3c',
    '#ecf0f1',
    '#f39c12',
    '#d35400',
    '#c0392b'
];

export function color(index: number) {
    return colorList[index % colorList.length];
}

export function generateID(): string {
    return Date.now().toString(16) + Math.random().toString(16);
}
